// extracted by extract-css-chunks-webpack-plugin
module.exports = {"ltoDetails":"_3ZPwve","adBugWrapper":"WrXGXq","tooltipWrapper":"_3rhY-u","detailsText":"_3M848L"};